import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './Discourse.module.scss';

const discourseClassNames = {
  container: styles.mainSection,
  title: styles.title,
  subtitle: styles.subtitle,
  sectionTitle: styles.sectionTitle,
  paragraph: styles.articleParagraph,
  emphasis: styles.emphasize,
  citation: styles.citation,
  imageSection: styles.mainImageSection,
  imageSectionSmall: styles.mainImageSectionSmall,
  imageContainer: styles.imageContainer,
  image: styles.mainImage,
  imageCaption: styles.mainImageCredit,
  captionInput: styles.captionInput,
  captionEditable: styles.captionEditable,
  captionPlaceholder: styles.captionPlaceholder,
  imageDeleteOverlay: styles.imageDeleteOverlay,
};

const DiscourseMainSection = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={discourseClassNames}
    />
  );
};

export default DiscourseMainSection;
